import { LookupSessionCode200 } from '../../../../../generated/model/lookupSessionCode200';
import { LookupSessionCode200GroupsItem } from '../../../../../generated/model/lookupSessionCode200GroupsItem';
import { lessonSlug, trackNumberFromName, trackSlug } from '@/shared/content/lesson-slug';
import { isGradeSlug } from '@/shared/utils/grade/grade';
import {
  FormedGroupView,
  VerifiedLessonCodeView,
  VerifiedStudentView,
} from './lesson-code-mappers.types';

function trailSlugFrom(track: LookupSessionCode200['lesson']['track']): string | null {
  const number = trackNumberFromName(track?.name);
  return number > 0 ? trackSlug(number) : null;
}

function byName(first: VerifiedStudentView, second: VerifiedStudentView): number {
  return first.name.localeCompare(second.name, 'pt-BR');
}

function toFormedGroup(group: LookupSessionCode200GroupsItem): FormedGroupView | null {
  const members = group.members.map((member) => ({ id: member.userId, name: member.name }));
  const organizer = members.find((member) => member.id === group.organizerUserId) ?? members[0];
  if (!organizer) return null;
  return {
    id: group.groupId,
    organizer,
    others: members.filter((member) => member !== organizer),
  };
}

export function toVerifiedLessonCode(dto: LookupSessionCode200): VerifiedLessonCodeView {
  return {
    lessonDocumentId: dto.lesson.documentId,
    lessonNumber: dto.lesson.number,
    lessonSlug: lessonSlug(dto.lesson.number),
    trailSlug: trailSlugFrom(dto.lesson.track),
    serieSlug: isGradeSlug(dto.serieSlug) ? dto.serieSlug : null,
    classGroupName: dto.classGroup.name,
    students: dto.students
      .map((student) => ({
        id: student.userId,
        name: student.name,
        unavailable: student.unavailable,
      }))
      .sort(byName),
    groups: dto.groups
      .map(toFormedGroup)
      .filter((group): group is FormedGroupView => group !== null),
  };
}
